module.exports = __webpack_public_path__ + "img/sign-in-with-linkedin.42a61829.png";